<template>
  <form @submit.prevent="submit">
    <smd-one-col-layout content-styles="view-pharmacy-orders-delivery-details__content">
      <full-screen-loader v-if="loading" :whiteBg="true"/>

      <div v-if="!loading" :class="{'view-pharmacy-orders-delivery__inner': desktopView}">

        <div class="smd-form__row m-b-25">
          <form-required-note/>
        </div>

        <!--   Delivery Details   -->
        <div class="smd-form__row">
          <text-string label-id="txt095"/>
        </div>

        <!--   Contact Person   -->
        <div class="smd-form__row m-b-10">
          <div class="smd-form__col">
            <label required
                   input-label
                   for="contactPerson"
                   :error="$v.contactPerson.$invalid && $v.contactPerson.$error">
              {{ getElementString('txt101') }}
              <span class="form-text-error"
                    v-if="$v.contactPerson.$invalid && $v.contactPerson.$error">
              {{ validationErrors.contactPerson }}
            </span>
            </label>
            <input type="text"
                   id="contactPerson"
                   v-model="$v.contactPerson.$model"
                   :placeholder="getElementString('txt105')">
          </div>
        </div>


        <!--   Mobile No.   -->
        <div class="smd-form__row m-b-30">
          <div class="smd-form__col">
            <label required
                   input-label
                   for="mobilenumber"
                   :error="$v.mobilenumber.$invalid && $v.mobilenumber.$error">
              {{ getElementString('txt102') }}
              <span class="form-text-error"
                    v-if="$v.mobilenumber.$invalid && $v.mobilenumber.$error">
              {{ validationErrors.mobilenumber }}
            </span>
            </label>
            <smd-phone-input v-model="$v.mobilenumber.$model"
                             id="mobilenumber"
                             ref="mobilenumber"
                             placeholder="9#########"
                             :error="$v.mobilenumber.$invalid && $v.mobilenumber.$error"
                             :has-value="!$v.mobilenumber.$error"/>
          </div>
        </div>

        <!--   House # / Building, Street, Barangay   -->
        <div class="smd-form__row m-b-20">
          <div class="smd-form__col">
            <label required
                   input-label
                   for="street"
                   :error="$v.street.$invalid && $v.street.$error">
              {{ getElementString('txt103') }}
              <span class="form-text-error"
                    v-if="$v.street.$invalid && $v.street.$error">
              {{ validationErrors.street }}
            </span>
            </label>
            <input v-model="$v.street.$model"
                   type="text"
                   id="street"
                   :placeholder="getElementString('txt103')"
                   :error="$v.street.$invalid && $v.street.$error"
                   :has-value="!$v.street.$invalid">
          </div>
        </div>

        <!--   Select City   -->
        <div class="smd-form__row m-b-20">
          <div class="smd-form__col">
            <label input-label
                   required>
              {{ getElementString('txt620') }}
            </label>
            <smd-list-selection-panel :has-text-string="true"
                                      :title="computedCityTitle"
                                      @selected="showCityModal"
                                      @change="showCityModal">
              <text-string slot="placeholder"
                           v-if="computedCityPlaceholder"
                           :label-id="computedCityPlaceholder"/>
              <span class="Title3 gray-900"
                    v-else
                    slot="title">
                    {{ computedCityTitle }}
                  </span>
              <span class="ns-icon-ico039 ns-large-icon" slot="icon">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                  </span>
            </smd-list-selection-panel>
          </div>
        </div>

        <!--   Notes/Landmarks/Map Pin   -->
        <div class="smd-form__row m-b-20">
          <div class="smd-form__col">
            <label input-label
                   for="buildingname">
              {{ getElementString('txt104') }}
            </label>
            <input v-model="buildingname"
                   type="text"
                   id="buildingname"
                   :placeholder="getElementString('txt104')">
          </div>
        </div>

        <div v-if="selectedPartnerIsAvailable" class="smd-form__row m-t-40 m-b-25">
          <text-string label-id="txt092"/>
        </div>

        <!-- partner images -->
        <div v-if="selectedPartnerIsAvailable" class="partners m-b-25">
          <template v-if="hasValidCoupon">
            <div class="coupon-partners">
              <img src="~@/assets/images/pharmacies/ico198.svg" alt="Southstar Drug Logo">
              <img src="~@/assets/images/pharmacies/ico199.svg" alt="Watson's Logo">
              <img src="~@/assets/images/pharmacies/ico200.svg" alt="Rose Pharmacy Logo">
              <img src="~@/assets/images/pharmacies/ico201.svg" alt="St. Joseph Drug Logo">
              <img src="~@/assets/images/pharmacies/ico202.svg" alt="Medexpress Drugstore Logo">
            </div>
          </template>
          <template v-else-if="nsPharmacyPartnered">
            <img src="~@/assets/images/ico048.svg" width="193.33px" alt="">
          </template>
          <template v-else>
            <img src="~@/assets/images/img006.png" width="193.8px" alt="">
          </template>
        </div>

        <!-- operational hours -->
        <div v-if="selectedPartnerIsAvailable" class="smd-form__row operational-hours m-b-30">
          <div class="smd-form__col">
            <template v-if="hasValidCoupon">
              <text-string label-id="txt051" class="m-b-5"/>
              <text-string label-id="txt143"/>
            </template>
            <template v-else-if="nsPharmacyPartnered">
              <!-- <text-string label-id="txt212"/> -->
              <div>
                <text-string label-id="txt051" class="m-b-5"/>
                <p class="Body1">Monday - Friday: 9am-5pm</p>
                <p class="Body1">Saturday: 8am-4pm</p>
              </div>
              <div>
                <span class="Label1 gray-400 m-b-5">Same-day Delivery Cutoff</span>
                <p class="Body1">Monday - Friday: 5pm</p>
                <p class="Body1">Saturday: 4pm</p>
              </div>
              <text-string label-id="txt093"/>
            </template>
            <template v-else>
              <text-string label-id="txt051" class="m-b-5"/>
              <text-string label-id="txt141" class="m-b-30"/>
              <text-string label-id="txt094"/>
            </template>
          </div>
        </div>

        <div v-if="selectedPartnerIsAvailable" class="delivery-details__terms">
          <text-string label-id="txt192"/>
        </div>

        <div v-if="isBlocked" class="delivery-details__blocked m-t-30">
          <p class="Body1 m-b-5">Our pharmacy is currently closed on the following dates:</p>
          <p v-for="(blockedDate, i) in partnerBlockedDates"
            :key="i">
            {{ blockedDate | blockedDateFormat }}
          </p>
          <p class="m-t-10">Acceptance and processing of orders will resume on the following available day.</p>
        </div>

        <div v-if="!selectedPartnerIsAvailable" class="delivery-details__blocked m-t-30 text-center">
          <p>The selected city is currently not serviceable.</p>
        </div>

        <div class="view-pharmacy-orders-delivery__footer-btn m-t-75"
             v-if="desktopView">
          <div class="smd-form__row">
            <smd-btn section="10"
                     variant="left-enabled"
                     @click="setActiveStep($options.PHARMACY_ORDERS_DISCOUNT)">
              <text-string label-id="txt109"/>
            </smd-btn>
            <smd-btn section="10"
                     type="submit"
                     :disabled="disableSubmit"
                     :variant="computedVariant">
              <text-string label-id="txt110"/>
            </smd-btn>
          </div>
        </div>
      </div>

      <!--   Bottom Nav   -->
      <div slot="bottom-nav"
           v-if="!desktopView">
        <div class="smd-form__row">
          <smd-btn section="2"
                   variant="left-enabled"
                   @click="setActiveStep($options.PHARMACY_ORDERS_DISCOUNT)">
            <text-string label-id="txt109"/>
          </smd-btn>
          <smd-btn section="2"
                   type="submit"
                   :disabled="disableSubmit"
                   :variant="computedVariant">
            <text-string label-id="txt110"/>
          </smd-btn>
        </div>
      </div>
    </smd-one-col-layout>
  </form>
</template>

<script>
  import {mapFields} from "vuex-map-fields";
  import {mapGetters} from "vuex";
  import moment from 'moment';
  import {isNSPharmacyCity} from "@leapfroggr/patientappcommons/dist/utils";

  import MedicineOrdersDeliveryDetailsMixin from '@/mixins/services/medicine-orders-delivery-details-mixin';
  import ModalTermsAndConditions from '@/modals/modal-terms-and-conditions';

  import {
    AVAILMENT_CODES,
    DEFAULT_PHARMACIES,
  } from '@/reference/medicine';

  import {
    GETTER_PRESCRIPTION_HAS_VALID_COUPON,
    GETTER_PHARMACY_ORDER_PARTNER,
    GETTER_PHARMACY_ORDER_IS_BLOCKED,
  } from "@/store/types";
  import {Reference} from "smd-vue-scaffold";

  export default {
    name: "view-pharmacy-orders-delivery-details",
    mixins: [
      MedicineOrdersDeliveryDetailsMixin,
    ],
    filters: {
      blockedDateFormat(date) {
        return moment.utc(date).add(24, 'hours').format('MMMM D, YYYY');
      },
    },
    computed: {
      ...mapGetters({
        hasValidCoupon: GETTER_PRESCRIPTION_HAS_VALID_COUPON,
        orderPartner: GETTER_PHARMACY_ORDER_PARTNER,
        isBlocked: GETTER_PHARMACY_ORDER_IS_BLOCKED,
      }),
      ...mapFields({
        partnercode: 'partnercode',
      }),
      nsPharmacyCityScoped() {
        return this.cityObject ? isNSPharmacyCity(this.cityObject) : false;
      },
      nsPharmacyPartnered() {
        return this.partnercode === DEFAULT_PHARMACIES.NS_PHARMACY;
      },
      partnerBlockedDates() {
        if (!this.orderPartner) return [];
        return this.orderPartner.blockeddates;
      },
      selectedPartnerIsAvailable() {
        // this is the only condition currently
        // made it to computed just in case there will be more conditions in the future
        return this.partnercode !== DEFAULT_PHARMACIES.medex_live;
      },
      disableSubmit() {
        return this.$v.$invalid || this.isBlocked || !this.selectedPartnerIsAvailable;
      },
    },
    watch: {
      partnercode(newPartnerCode) {
        this.availmentCode = newPartnerCode === DEFAULT_PHARMACIES.NS_PHARMACY
          ? AVAILMENT_CODES.NSPH
          : null;
      },
      city() {
        this.setPartnerCode();
      },
      hasValidCoupon: {
        handler() {
          this.setPartnerCode();
        },
        immediate: true,
      },
    },
    methods: {
      openTermsModal() {
        this.$modal.open({
          component: ModalTermsAndConditions,
          size: this.$isMobile ? Reference.SmdModalSizes.xs : Reference.SmdModalSizes.sm,
          closeOnBackdrop: false,
        });
      },
      setPartnerCode() {
        this.partnercode = this.hasValidCoupon
          ? DEFAULT_PHARMACIES.NS_PHARMACY
          : (this.nsPharmacyCityScoped || !this.cityObject)
            ? DEFAULT_PHARMACIES.NS_PHARMACY
            : DEFAULT_PHARMACIES.medex_live;
      },
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .view-pharmacy-orders-delivery__inner {
    @include box-shadow();
    @include border-radius();
    background: color(white);
    padding: space(base) space(xxxl) 0;
    position: relative;
    max-width: 900px;
    margin-right: space(xxl);

    @include responsive('max-width: 1023px') {
      margin-right: 0;
    }
    @include responsive('min-width: 1800px') {
      margin: 0 auto;
    }
  }

  .view-pharmacy-orders-delivery__footer-btn {
    margin-left: -60px;
    margin-right: -60px;
  }

  .view-pharmacy-orders-delivery-details__content {
    padding-bottom: space(xxl) !important;
    padding-top: space(xl) !important;

    .delivery-details__terms {
      text-align: center;
      max-width: 300px;
      margin: 0 auto;
    }

    .coupon-partners {
      @extend %layout--flex-row-center-x;
      flex-wrap: wrap;
      justify-content: space-around;

      img {
        max-width: 150px;
        margin-right: space(s);
        margin-bottom: space(m-base);
      }
    }

    .delivery-details__blocked {
      color: color(red, brand);
    }
  }
</style>